'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var Cell = _interopDefault(require('../cell'));
var CellLeft = _interopDefault(require('../cell-left'));
var CellRight = _interopDefault(require('../cell-right'));
var SuspendMenu = _interopDefault(require('../suspend-menu'));

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('suspend-menu', {
      staticClass: "bankcard-sheet",
      attrs: {
        "show": _vm.show
      },
      on: {
        "clickMask": function clickMask($event) {
          _vm.$emit('hide');
        }
      }
    }, [_c('div', {
      staticClass: "bankcard-sheet-title",
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "icon-error bankcard-sheet-close",
      on: {
        "click": function click($event) {
          _vm.$emit('hide');
        }
      }
    }), _vm._v(" "), _vm.notification ? _c('div', {
      staticClass: "bankcard-sheet-notification",
      domProps: {
        "innerHTML": _vm._s(_vm.notification)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bankcard-sheet-box"
    }, _vm._l(_vm.options, function (item, index) {
      return _c('cell', {
        directives: [{
          name: "tap",
          rawName: "v-tap"
        }],
        key: index,
        staticClass: "bankcard-sheet-option",
        class: {
          disabled: item.disabled
        },
        attrs: {
          "access": !item.disabled
        },
        on: {
          "click": function click($event) {
            !item.disabled && item.onClick(index);
          }
        }
      }, [_c('cell-left', {
        class: {
          'bankcard-sheet-tip': item.tip
        },
        attrs: {
          "icon": item.logo
        }
      }, [_c('div', {
        staticClass: "content"
      }, [_c('div', {
        staticClass: "text"
      }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
        staticClass: "tip"
      }, [_vm._v(_vm._s(item.tip))])])]), _vm._v(" "), _c('cell-right', [item.rightTick ? _c('i', {
        staticClass: "icon-success bankcard-sheet-tick"
      }) : _c('div', {
        domProps: {
          "innerHTML": _vm._s(item.rightText)
        }
      })])], 1);
    }), 1)]);
  },
  staticRenderFns: [],
  name: 'bankcard-sheet',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: '选择支付方式'
    },
    options: Array,
    notification: String
  },
  components: {
    Cell: Cell,
    CellLeft: CellLeft,
    CellRight: CellRight,
    SuspendMenu: SuspendMenu
  }
});

exports.default = index;
